// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2fmZV","calendarButtons":"ClockData_calendarButtons__2zlr6"};